"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnchorManual = exports.isAnchorP2P = exports.isAnchorLocationGPS = exports.isFileData = exports.isCaptureData = exports.isLink = exports.isHeightProviderManual = exports.isHeightPhotomeasureManualProvider = exports.isHeightPhotomeasureProvider = exports.isHeightSpanHeightProvider = exports.isVectorProviderManual = exports.isVectorCollectionProvider = exports.isVectorPointToPointProvider = exports.isMaskDrawable = exports.isLineDrawable = exports.isMarkerDrawable = exports.isHiddenImageVisibility = exports.isGammaBrightnessCorrection = exports.isFreeCropParameter = void 0;
exports.findObjectsWhere = findObjectsWhere;
var isFreeCropParameter = function (o) { return o.tag === 'free'; };
exports.isFreeCropParameter = isFreeCropParameter;
var isGammaBrightnessCorrection = function (o) { return o.tag === 'gamma'; };
exports.isGammaBrightnessCorrection = isGammaBrightnessCorrection;
var isHiddenImageVisibility = function (o) { return o.tag === 'hidden'; };
exports.isHiddenImageVisibility = isHiddenImageVisibility;
var isMarkerDrawable = function (o) { return o.tag === 'marker'; };
exports.isMarkerDrawable = isMarkerDrawable;
var isLineDrawable = function (o) { return o.tag === 'line'; };
exports.isLineDrawable = isLineDrawable;
var isMaskDrawable = function (o) { return o.tag === 'mask'; };
exports.isMaskDrawable = isMaskDrawable;
var isVectorPointToPointProvider = function (fieldData) { return fieldData.provider === 'pointtopoint'; };
exports.isVectorPointToPointProvider = isVectorPointToPointProvider;
var isVectorCollectionProvider = function (fieldData) { return fieldData.provider === 'collection'; };
exports.isVectorCollectionProvider = isVectorCollectionProvider;
var isVectorProviderManual = function (fieldData) { return fieldData.provider === 'manual'; };
exports.isVectorProviderManual = isVectorProviderManual;
var isHeightSpanHeightProvider = function (fieldData) { return fieldData.provider === 'spanheight'; };
exports.isHeightSpanHeightProvider = isHeightSpanHeightProvider;
var isHeightPhotomeasureProvider = function (fieldData) { return fieldData.provider === 'photomeasure'; };
exports.isHeightPhotomeasureProvider = isHeightPhotomeasureProvider;
var isHeightPhotomeasureManualProvider = function (fieldData) { return fieldData.provider === 'photomeasuremanual'; };
exports.isHeightPhotomeasureManualProvider = isHeightPhotomeasureManualProvider;
var isHeightProviderManual = function (fieldData) { return fieldData.provider === 'manual'; };
exports.isHeightProviderManual = isHeightProviderManual;
var isLink = function (fieldData) { return fieldData.provider === 'collection'; };
exports.isLink = isLink;
var isCaptureData = function (object) { return object.camera != null && object.camera.imageuuid != null; };
exports.isCaptureData = isCaptureData;
var isFileData = function (object) { return object.attachmentId != null && object.size != null; };
exports.isFileData = isFileData;
var isAnchorLocationGPS = function (object) { return object.value.collectionTool === 'LOCATION' && object.provider === 'gps'; };
exports.isAnchorLocationGPS = isAnchorLocationGPS;
var isAnchorP2P = function (object) { return object.value.collectionTool === 'VECTOR' && object.provider === 'pointtopoint'; };
exports.isAnchorP2P = isAnchorP2P;
var isAnchorManual = function (object) { return object.value.collectionTool === 'VECTOR' && object.provider === 'manual'; };
exports.isAnchorManual = isAnchorManual;
function findObjectsWhere(data, pred) {
    if (pred(data)) {
        return [data];
    }
    var found = [];
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = data[key];
        if (value && typeof value === 'object') {
            found = found.concat(findObjectsWhere(value, pred));
        }
    }
    return found;
}
//# sourceMappingURL=collection.model.util.js.map